import { useCallback, useMemo, useState } from 'react';
import {
  createFeatureBacklogItem,
  loadFeatureBacklog,
  persistFeatureBacklog,
  sortBacklog,
  type FeatureBacklogItem,
  type FeatureRequestInput,
  type FeatureStatus,
} from '../services/featureBacklog';

export function useFeatureBacklog() {
  const [items, setItems] = useState<FeatureBacklogItem[]>(() => loadFeatureBacklog());

  const backlog = useMemo(() => sortBacklog(items), [items]);

  const addFeatureRequest = useCallback((input: FeatureRequestInput, currentPage: string) => {
    const nextItem = createFeatureBacklogItem(input, currentPage);
    setItems((current) => {
      const next = sortBacklog([nextItem, ...current]);
      persistFeatureBacklog(next);
      return next;
    });
    return nextItem;
  }, []);

  const updateFeatureStatus = useCallback((id: string, status: FeatureStatus) => {
    setItems((current) => {
      const next = current.map((item) => item.id === id ? { ...item, status } : item);
      persistFeatureBacklog(next);
      return sortBacklog(next);
    });
  }, []);

  return { backlog, addFeatureRequest, updateFeatureStatus };
}